import { render, staticRenderFns } from "./VerticalNavFooter.vue?vue&type=template&id=7c179265"
import script from "./VerticalNavFooter.vue?vue&type=script&lang=js"
export * from "./VerticalNavFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports